const oneSecond = 1000;
const oneMinuteInMilliseconds = oneSecond * 60;
const oneHourInMilliseconds = oneMinuteInMilliseconds * 60;

export const time = {
  tenSecs: oneSecond * 10,
  thirtySecs: oneSecond * 30,
  oneMinuteInMilliseconds,
  tenMinutesInMilliseconds: oneMinuteInMilliseconds * 10,
  oneHourInMilliseconds,
  oneDayInMilliseconds: oneHourInMilliseconds * 24,
};
